import React from 'react';


export default function DemographicPendingBanner({ onDismiss }) {
  return (
    <div className="w-full bg-amber-500/10 border-b border-amber-500/30 px-4 py-3 flex items-center justify-between gap-4">
      <p className="text-sm text-amber-300">
        Your demographic information has been submitted and is awaiting
        verification. You'll be notified once it's reviewed.
      </p>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="text-xs text-amber-400/70 hover:text-amber-300 shrink-0"
        >
          Dismiss
        </button>
      )}
    </div>
  );
}